import useDataHook from "./useDataHook";

function Gistviewer() {
    const [loading, data, errors] = useDataHook('https://api.github.com/users/RalphD42/gists', null);

    return (<>

        {loading ? <div>Loading</div> : <ul>
            {data.map((x => <li key={x.id}> <a href={x.html_url} target='_blank' rel='noreferrer' >{x.description} </a> </li>))}
        </ul>}


        {errors && <div>{errors}</div>}

    </>
    )
}



export default Gistviewer;